import { writable } from "svelte/store";

export const dashboardSearchTerm = writable("");
